import { ReceptionCommentUnitKinds, ReceptionCommentSortItemKinds, ReceptionCommentKinds } from "../kinds";

// コメント表示設定model
export class ReceptionCommentDispInfo {
  constructor() {
    this.commentMode = ReceptionCommentUnitKinds.Multiple; // 複数（デフォルト
    this.restrictCommentMode = ReceptionCommentUnitKinds.Multiple;
    this.nextMessageMode = ReceptionCommentUnitKinds.Single;
    this.contactedCommentMode = ReceptionCommentUnitKinds.Multiple;
    this.delCommentMode = ReceptionCommentUnitKinds.Multiple;
    this.isAdminCommentTabEnable = false;
    this.isRestrictCommentEnable = false;
    this.isContactedCommentEnable = false;
    this.isDelCommentEnable = false;
    this.isCommentRegisterable = false;
    this.isRestrictCommentRegisterable = false;
    this.isNextMessageRegisterable = false;
    this.isContactedCommentRegisterable = false;
    this.isDelCommentRegisterable = false;
    this.shouldShowCommentsMixed = false;
    this.mixedCommentBackgroundColor = "#B79F7C";
    this.mixedRestrictedBackgroundColor = "#B79F7C";
    this.mixedNextMessageBackgroundColor = "#B79F7C";
    this.mixedBackMessageBackgroundColor = "#B79F7C";
    this.mixedContactedInfoBackgroundColor = "#B79F7C";
    this.mixedDelCommentBackgroundColor = "#B79F7C";
    this.mixedConflictBackgroundColor = "#B79F7C";
  }

  // コメントモード
  public commentMode: ReceptionCommentUnitKinds;

  // 閲覧制限のモード（管理単位）
  public restrictCommentMode: ReceptionCommentUnitKinds;

  // 伝達事項のモード（管理単位）
  public nextMessageMode: ReceptionCommentUnitKinds;

  // 連絡済みコメントのモード（管理単位）
  public contactedCommentMode: ReceptionCommentUnitKinds;

  // 削除コメントのモード（管理単位）
  public delCommentMode: ReceptionCommentUnitKinds;

  // コメントの並び順の既定値
  public commentDefaultSortType: ReceptionCommentSortItemKinds;

  // 管理者用コメントタブ表示有無
  public isAdminCommentTabEnable: boolean;

  // 閲覧制限コメント権限有無(追加できるか)
  public isRestrictCommentEnable: boolean;

  // 連絡済情報運用有無
  public isContactedCommentEnable: boolean;

  // 削除コメント表示有無
  public isDelCommentEnable: boolean;

  // 一般コメントの追加可否
  public isCommentRegisterable: boolean;

  // 閲覧制限コメントの追加可否
  public isRestrictCommentRegisterable: boolean;

  // 伝達事項の追加可否
  public isNextMessageRegisterable: boolean;

  // 連絡済み情報の追加可否
  public isContactedCommentRegisterable: boolean;

  // 削除理由の追加可否
  public isDelCommentRegisterable: boolean;

  // WF一覧などのコメントタブでコメントを種類で分けないで表示するかどうか
  public shouldShowCommentsMixed: boolean;

  // WF一覧などのコメントタブでコメントを種類で分けないで表示する場合に、コメント追加画面で初期選択するコメント種別
  public commentsMixedDefaultAdditionalCommentType: ReceptionCommentKinds;

  // WF一覧などのコメントタブでコメントを種類で分けないで表示する場合の、コメントラベルの背景色
  public mixedCommentBackgroundColor: string;

  // WF一覧などのコメントタブでコメントを種類で分けないで表示する場合の、閲覧制限コメントラベルの背景色
  public mixedRestrictedBackgroundColor: string;

  // WF一覧などのコメントタブでコメントを種類で分けないで表示する場合の、伝達事項ラベルの背景色
  public mixedNextMessageBackgroundColor: string;

  // WF一覧などのコメントタブでコメントを種類で分けないで表示する場合の、差戻しコメントラベルの背景色
  public mixedBackMessageBackgroundColor: string;

  // WF一覧などのコメントタブでコメントを種類で分けないで表示する場合の、連絡済み情報ラベルの背景色
  public mixedContactedInfoBackgroundColor: string;

  // WF一覧などのコメントタブでコメントを種類で分けないで表示する場合の、削除理由ラベルの背景色
  public mixedDelCommentBackgroundColor: string;

  // WF一覧などのコメントタブでコメントを種類で分けないで表示する場合の、競合コメントラベルの背景色
  public mixedConflictBackgroundColor: string;

  // コメントを昇順にするかどうか
  public shouldSortCommentAsc: boolean;
}
